import { useStyletron } from 'baseui'
import { SIZE } from 'baseui/button'
import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import ContractActionsModal from './ContractActionsModal'
import useContractActions from './useContractActions'

interface ActionsCellProps {
  contractId: string
  contractUserId: string
  contactZohoId: string
  statusRaw: string
  contactId: string
  getContracts: () => void
  formInitUrl: string
}

const ActionsCell = (props: ActionsCellProps) => {
  const { t } = useTranslation()
  const [css] = useStyletron()
  const {
    isOpen,
    modalType,
    openContract,
    openAbandon,
    openComments,
    dismissModal,
    stopPropagation,
    handleAbandonSubmit,
    handleCommentSubmit,
    isLoadingComments,
    comments,
    canAbandon,
  } = useContractActions(props)

  const containerStyle = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '.25rem',
  })

  return (
    <div className={containerStyle} onClick={stopPropagation}>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton size={SIZE.mini} block onClick={openContract}>
        {t('contractsTable:edit')}
      </SDButton>

      {canAbandon && (
        /* @ts-expect-error SDButton is a JS component */
        <SDButton size={SIZE.mini} block onClick={openAbandon}>
          {t('contractsTable:abandon')}
        </SDButton>
      )}

      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton size={SIZE.mini} block onClick={openComments}>
        {t('contractsTable:comments')}
      </SDButton>

      <ContractActionsModal
        isOpen={isOpen}
        modalType={modalType}
        onClose={dismissModal}
        onAbandonSubmit={handleAbandonSubmit}
        onCommentSubmit={handleCommentSubmit}
        comments={comments}
        isLoadingComments={isLoadingComments}
      />
    </div>
  )
}

export default ActionsCell
